import { COMMUNITY_PAGES_PATH_PREFIX } from "../styling/types"

export const isCheckoutPage = (url: string) => {
  return !!url.includes("/checkout")
}

export const isLandingPage = (pathname: string) => {
  return pathname === `${COMMUNITY_PAGES_PATH_PREFIX}/[code]`
}
